import { AttachmentCoreBase } from "./attachment.core.base"


export class AttachmentCore extends AttachmentCoreBase {

}